import React, { FC } from 'react';
import { Button, Appearance } from '@src/components/Button';
import { STATIC_MEDIA_DOMAIN } from '@src/constants';
import { Image } from '@src/components/Image';
import { LastSlideProps } from './props';
import './styles.scss';

export const LastSlide: FC<LastSlideProps> = ({ onClick }) => {
  return (
    <div className="applicant-modal-last-slide">
      <div className="applicant-modal-last-slide__container">
        <Image className="applicant-modal-last-slide__image" src={`${STATIC_MEDIA_DOMAIN}/images/ta-empty-state.png`} />
        <h3>You’ve reached the end!</h3>
        <p>Check back tomorrow to see another batch of featured applicants. We'll also notify you via email.</p>
        <Button appearance={Appearance.INVISIBLE} className="applicant-modal-last-slide__button" onClick={onClick}>
          Close
        </Button>
      </div>
    </div>
  );
};
